import { useMemo } from 'react';
import { useSelectedCall } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import { getMostRecentLocations } from '@rsos/utils/getMostRecentLoc';
import RequestAdr from './RequestAdr';
import { useHasAccessToRequestAdr } from './selectors/selectors';

const AdrQueryContainer = () => {
  const selectedCall = useSelectedCall();
  const hasAccessToViewButton = useHasAccessToRequestAdr();

  const shouldRender = useMemo(() => {
    const mostRecentLoc =
      getMostRecentLocations(selectedCall)?.mostRecentLocation;
    return (
      !!hasAccessToViewButton &&
      mostRecentLoc?.application?.toLowerCase() === 'ios'
    );
  }, [hasAccessToViewButton, selectedCall]);

  if (!shouldRender) {
    return null;
  }

  return <RequestAdr />;
};

export default AdrQueryContainer;
